import React from 'react';
import ContentLoader from 'react-content-loader';
import { fakeSettings } from '@/constants/constants';
import styles from './styles';
// import Card from '@gerenciatd/next.components.card-n';


const SecureConnectionFake = () => {
  return (
    <div className="secureConnectionFake">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12" >
            {/* <Card> */}
              <ContentLoader
                height="590"
                width="560"
                {...fakeSettings}
              >
                <rect x="200" y="20" width="160" height="20" rx="1" ry="1" />
                <circle cx="280" cy="70" r="20" />
                <rect x="100" y="110" width="350" height="110" rx="1" ry="1" />
                <rect x="200" y="280" width="160" height="20" rx="1" ry="1" />
              </ContentLoader>
            {/* </Card> */}
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}


export default SecureConnectionFake;
